module.exports = __webpack_public_path__ + "img/cooperation06.b7c95857.png";